'use client';
import {usePublicCopy} from './content/navigation';
import {getTutorialCopy} from './content/tutorial-copy';
import styles from './tutorial-steps.module.css';

export function TutorialSteps({id='full-tutorial',standalone=false}:{id?:string;standalone?:boolean}) {
  const {locale}=usePublicCopy(),copy=getTutorialCopy(locale);
  const Heading=standalone?'h1':'h2';
  return (
    <section className={styles.tutorial} id={id} aria-labelledby={`${id}-title`} data-standalone={standalone}>
      <header className={styles.heading}>
        <Heading id={`${id}-title`}>{copy.title}</Heading>
        <p>{copy.description}</p>
      </header>
      <ol className={styles.grid} role="list" aria-label={copy.timelineLabel}>
        {copy.guides.map(guide=>(
          <li className={styles.card} key={guide.id}>
            <span className={styles.number} aria-hidden="true">STEP {guide.id}</span>
            <h3>{guide.title}</h3>
            <ul className={styles.points}>
              {guide.points.map(point=><li key={point}>{point}</li>)}
            </ul>
            <div className={styles.result}>
              <span>{copy.completeLabel}</span>
              <strong>{guide.result}</strong>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
